// cache em memória, escopo global ou de módulo
const memoryCache = {};

/**
 * Faz fetch e armazena em cache usando uma chave.
 * @param {string} key - Chave única para identificar os dados no cache.
 * @param {string} url - Caminho ou endpoint da requisição.
 * @param {object} [options] - Opções para passar ao fetch (opcional).
 * @returns {Promise<any>} Dados retornados da requisição (ou do cache).
 */
export async function fetchWithMemoryCache(key, url, options = {}) {
  if (memoryCache[key]) {
    return memoryCache[key];
  }

  const response = await fetch(url, options);
  if (!response.ok) {
    if(response.status === 404) {   
      window.location.href = "/flu";
    }

    throw new Error(`Requisição falhou: ${response.status}`);
  }

  const data = await response.json();

  memoryCache[key] = data;

  return data;
}
